import './styles/global.css';
import { Header } from "./Header";
import { Outlet } from 'react-router-dom';

const BusinessToolMarketPlace = () => {
  return (
    <div>
      <Header />
      <Outlet />
    </div>
  )
}
export default BusinessToolMarketPlace;